/* オンライン本人確認 */
import React, { useEffect } from 'react';
import { InputGroup } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import { KeyValue } from '../types/KeyValue';
import Messages from './Messages';
import Paragraph from './Paragraph';
import { use_large_label } from '../const/RadioButton';
import CenterButton from '../atoms/CenterButton';
import { online_identification } from '../Const';
interface Props {
  id: string;
  css_class?: string;
  label: string;
  need?: boolean;
  sources: Array<KeyValue>;
  name: string;
  value: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  message?: string;
  help_msg?: string;
  disabled: boolean;
  handleBlur?: VoidFunction;
  looks_inactive?: boolean;
  readonly?: boolean;
  callApi: (function_name: string, should_loading?: boolean, show_error?: boolean) => Promise<any>;
  show_error_nav: boolean;
  setIsImplementOnlineIdentification?: React.Dispatch<React.SetStateAction<boolean>>;
  module_name: string;
  is_agricultural_modernization_funds?: boolean;
  is_corporate_user?: boolean;
}

const OnlineIdentification: React.FC<Props> = ({
  id,
  css_class,
  label,
  need,
  sources,
  name,
  value,
  handleChange,
  message,
  help_msg,
  disabled,
  handleBlur,
  looks_inactive,
  readonly,
  callApi,
  show_error_nav,
  setIsImplementOnlineIdentification,
  module_name,
  is_agricultural_modernization_funds,
  is_corporate_user,
}) => {
  useEffect(() => {
    if (typeof setIsImplementOnlineIdentification !== 'undefined') {
      setIsImplementOnlineIdentification(value === online_identification.implementation);
    }
  }, [value]);

  /**
   * 通常のラジオボタンをボタンを描画する
   * @return JSX.Element ラジオボタンのElement
   */
  const returnOnlineIdentificationJsx = () => {
    return (
      <>
        <InputGroup>
          {sources.map((src, index) => {
            // 法人ユーザーで農業資金・近代化資金の場合「実施する」を非活性
            if (src.key === '0' && is_agricultural_modernization_funds && is_corporate_user) {
              return (
                <label
                  className={`radio-label ${src.value.length >= use_large_label &&
                    'radio-label-large'}`}
                  key={src.key}
                >
                  <input
                    id={`${id}-${index}`}
                    type="radio"
                    value={src.key}
                    name={name}
                    checked={src.key === value}
                    onChange={handleChange}
                    disabled={true}
                    onBlur={handleBlur}
                    className="input-radio"
                  />
                  <span className={message ? 'radio-icon_valid' : 'radio-icon'}></span>
                  {src.value}
                </label>
              );
            } else {
              return (
                <label
                  className={`radio-label ${src.value.length >= use_large_label &&
                    'radio-label-large'}`}
                  key={src.key}
                >
                  <input
                    id={`${id}-${index}`}
                    type="radio"
                    value={src.key}
                    name={name}
                    checked={src.key === value}
                    onChange={handleChange}
                    disabled={disabled || readonly}
                    onBlur={handleBlur}
                    className="input-radio"
                  />
                  <span className={message ? 'radio-icon_valid' : 'radio-icon'}></span>
                  {src.value}
                </label>
              );
            }
          })}
        </InputGroup>
        <Messages help_msg={help_msg} valid_msg={message} />
      </>
    );
  };

  /**
   * ラベルを描画する
   * @return JSX.Element ラベルのElement
   */
  const returnLabelJsx = () => {
    return <>{sources.map(src => src.key === value && <Paragraph key={id} label={src.value} />)}</>;
  };

  return (
    <>
      <RowTemplate
        label={label}
        need={need}
        disabled={disabled}
        looks_inactive={looks_inactive}
        content={
          <div className={`p-radio ${css_class ?? ''}`}>
            {disabled || looks_inactive ? returnLabelJsx() : returnOnlineIdentificationJsx()}
          </div>
        }
      />
      {disabled || looks_inactive ? null : (
        <div className="mt-5">
          <CenterButton
            label="オンライン本人確認を実施する"
            btn_class="btn-base"
            is_disabled={value !== online_identification.implementation}
            handleClick={() => {
              callApi(module_name, true, show_error_nav);
            }}
          />
        </div>
      )}
    </>
  );
};

export default OnlineIdentification;
